import { useState } from 'react';
import { Package } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ProductThumbnailProps {
  src: string;
  alt: string;
  className?: string;
}

/**
 * Mock product images point at `/mock/*.jpg` paths that don't exist in this
 * static build (there's no real asset pipeline behind this demo data yet).
 * Rather than let every row show a broken-image icon, fall back to a plain
 * icon tile on load error — keeps the table looking intentional instead of
 * broken once real image URLs replace the mocks later.
 */
export function ProductThumbnail({ src, alt, className }: ProductThumbnailProps) {
  const [errored, setErrored] = useState(false);

  if (errored) {
    return (
      <div
        className={cn(
          'flex h-10 w-10 shrink-0 items-center justify-center rounded-md border border-border bg-muted text-muted-foreground',
          className
        )}
      >
        <Package className="h-4 w-4" />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      onError={() => setErrored(true)}
      className={cn('h-10 w-10 shrink-0 rounded-md border border-border object-cover', className)}
    />
  );
}

export default ProductThumbnail;
